import { Controller } from "@hotwired/stimulus"

// Warns users when leaving a page with unsaved form changes
// Usage: Add data-controller="unsaved-changes" to the form element
export default class extends Controller {
  static values = {
    message: { type: String, default: "You have unsaved changes. Are you sure you want to leave this page?" }
  }

  connect() {
    this.isDirty = false
    this.isSubmitting = false

    // Track all form input changes
    this.element.addEventListener("input", this.markDirty)
    this.element.addEventListener("change", this.markDirty)

    // Don't warn when form is being submitted
    this.element.addEventListener("submit", this.handleSubmit)

    // Warn before leaving page
    window.addEventListener("beforeunload", this.handleBeforeUnload)

    console.log("UnsavedChangesController connected")
  }

  disconnect() {
    this.element.removeEventListener("input", this.markDirty)
    this.element.removeEventListener("change", this.markDirty)
    this.element.removeEventListener("submit", this.handleSubmit)
    window.removeEventListener("beforeunload", this.handleBeforeUnload)
  }

  markDirty = () => {
    this.isDirty = true
  }

  handleSubmit = () => {
    this.isSubmitting = true
  }

  handleBeforeUnload = (event) => {
    if (this.isDirty && !this.isSubmitting) {
      event.preventDefault()
      // Modern browsers ignore custom messages but still show a generic prompt
      event.returnValue = this.messageValue
      return this.messageValue
    }
  }
}
